export function currentV2Locale(): string {
    return window.__V2__?.locale ?? 'pt_BR';
}

export function acceptLanguageHeader(locale = currentV2Locale()): string {
    return locale.replace('_', '-');
}
